import { CartActionType, CartModel, Set_Cart } from "./cart.models";

const initialState: CartModel = {
  shipName: "",
  shipPhoneNumber:"",
  addressId:0,
  totalAmount: 0,
  shippingFee: 0,
  couponCode: "",
  discountAmount: 0,
  phoneNumber: "",
  email: "",
  name: "",
  address: "",
  districtId: "",
  districtName: "",
  provinceId: "",
  provinceName: "",
  wardId: "",
  wardName: "",
  subTotalAmount: 0,
  customerId: "",
  customerName: "",
  shoppingCartItems: []
};

export function cartReducer(
  state = initialState,
  action: CartActionType
): CartModel {
  switch (action.type) {
    case Set_Cart:
      return action.payload;
    default:
      return state;
  }
}
